<template>
    <li class="shadow cursor-pointer" :style="stripped ? 'background-color: rgb(250, 250, 250)' : ''">
        <div class="chat__contact items-center px-2 pt-4 pb-2" :class="{'bg-primary-gradient text-white shadow-lg' : isSelected}" @click="$emit('selected', id)">
            <div class="contact__container w-full items-center justify-between overflow-hidden" >
                <div class="contact__info flex truncate w-full">
                    <div class="flex">
                        <h5 
                            class="font-semibold mt-1 pl-2 w-6/12" 
                            :class="{'text-white' : isSelected}">
                                    <a-icon class="transition" type="double-right" v-if="isSelected" />
                                    {{ orderNumber }}
                        </h5>
                        <span 
                            :class='`text-sm ml-4 ${(getStatus(statusId)).color} ${isSelected ? "text-white" : ""}`' 
                            style="position:relative; top:4px"> 
                            <a-icon :type="(getStatus(statusId)).icon" /> 
                            ({{ (getStatus(statusId)).description }}) 
                        </span>
                    </div>
                    
                    <span class="truncate text-right w-full pr-2"> {{ date | moment('DD/MM - HH:mm') }} </span>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
    export default {
        props : {
            orderNumber : {
                type: Number,
                required : false
            },

            date : {
                type: Date,
                required : true
            },

            id : {
                type : String,
                required : true,
            },

            statusId : {
                type : Number,
                required : true
            },

            stripped : {
                type : Boolean,
                required : false
            },

            isSelected : {
                type : Boolean,
                required : false
            }
        },

        methods : {
            getStatus (id) {
                const status = [
                            { description : 'pendente', color : 'text-danger', icon:"exclamation-circle" },
                            { description : 'aceito', color : 'text-success', icon:"check" },
                            { description : 'em produção', color : 'text-success', icon:"check" },
                            { description : 'concluído', color : 'text-success', icon:"check" }
                            ]
                return status[id]
            },
        }
    }
</script>